module.exports = __webpack_public_path__ + "media/fonts/CircularStd-Medium-bba31ddc6a13eea7712ea6185f87e298.eot";